module.exports = __webpack_public_path__ + "img/report.aeea05f0.png";